import { render, staticRenderFns } from "./goodsListPage.vue?vue&type=template&id=50b6b956&scoped=true"
import script from "./goodsListPage.vue?vue&type=script&lang=js"
export * from "./goodsListPage.vue?vue&type=script&lang=js"
import style0 from "./goodsListPage.vue?vue&type=style&index=0&id=50b6b956&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b6b956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b6b956')) {
      api.createRecord('50b6b956', component.options)
    } else {
      api.reload('50b6b956', component.options)
    }
    module.hot.accept("./goodsListPage.vue?vue&type=template&id=50b6b956&scoped=true", function () {
      api.rerender('50b6b956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/goodsListPage.vue"
export default component.exports